// msal
import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

// utils
import { parseJwt } from './jwt';

export interface GetTokenProps {
	account: AccountInfo;
	instance: IPublicClientApplication;
}

export const getToken = async ({ account, instance }: GetTokenProps) => {
	const resToken = await instance.acquireTokenSilent({
		account,
		forceRefresh: true,
		scopes: ['user.read'],
	});

	// set storage
	if (resToken.accessToken && resToken.idToken) {
		sessionStorage.setItem('accessToken', resToken.accessToken);
		sessionStorage.setItem('idToken', resToken.idToken);
		sessionStorage.setItem('token', JSON.stringify(resToken));
	}

	return resToken;
};

export interface IsTokenExpiredProps {
	token: string;
}

export const isTokenExpired = async ({ token }: IsTokenExpiredProps) => {
	const { payload } = parseJwt(token);

	let isExpired = true;

	if (payload.exp) {
		const currentTimeInSecs = Math.round(new Date().getTime() / 1000);
		isExpired = Number(payload.exp) < currentTimeInSecs;
	}

	return isExpired;
};
